module.exports = __webpack_public_path__ + "img/ring_a-2097.62d038b.jpg";